import PropTypes from 'prop-types'
import React from 'react'
import {
  Alert,
  ProgressBar
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import classes from './Toasts.module.scss'

export class Toasts extends React.Component {
  static propTypes = {
    toasts: PropTypes.array.isRequired,

    removeToast: PropTypes.func.isRequired
  }

  render () {
    const {
      toasts,

      removeToast
    } = this.props

    return (
      <div className={classes.toasts}>
        {toasts.map(toast =>
          <Alert
            key={toast.id}
            bsStyle={toast.type}
          >
            <div className={classes.messageWrapper}>
              <div className={classes.messageContainer}>
                {toast.message}
              </div>
              {toast.close &&
                <div
                  className={classes.close}
                  onClick={() => {
                    removeToast({ id: toast.id })
                    if (toast.onClose) toast.onClose()
                  }}
                >
                  <KanBoIcon name='kanbo-16-remove' />
                </div>
              }
            </div>
            {toast.progress !== false &&
              <div style={{ marginTop: '10px' }}>
                <ProgressBar
                  now={toast.progress}
                  bsStyle={toast.progress === 100 ? 'success' : 'default'}
                />
              </div>
            }
          </Alert>
        )}
      </div>
    )
  }
}

export default Toasts
